import React, { useEffect, useState } from 'react'
import HeaderMiniso from '../Components/HeaderMiniso'
import FooterMiniso from '../Components/FooterMiniso'
import { IoHomeOutline } from "react-icons/io5";
import { useNavigate } from 'react-router';
import useUser from '../../../hooks/useUser';
import CreateEditMonitorUser from '../Components/CreateEditMonitorUser';
import DeleteMonitorUser from '../Components/DeleteMonitorUser';
import TableMonitorUsers from '../Components/TableMonitorUsers';
import Dropdown from 'react-bootstrap/Dropdown';
import { MdMenu } from "react-icons/md";


const actionsArray = [
    <CreateEditMonitorUser />,
    <DeleteMonitorUser />,
    <TableMonitorUsers />
];

const AdminMonitor = () => {
    const navigate = useNavigate();
    const [actionMonitor, setActionMonitor] = useState(null);
    const [a,b,c,d,e,f,g,monitorUser,setMonitorUser,setDataMonitorLocalStorage,initialMonitorUser] = useUser();

    useEffect(() => {
        if (monitorUser?.user === "") {
          //console.log("monitorUser is FALSE:..", monitorUser);
          navigate("/loginMonitor");
        }
      }, [monitorUser]);

    const handleHome = (e) => {
        e.preventDefault();
        console.log('handleHome:....');
        navigate('/loginMonitor');
    }
    const handleLogout = () => {
        setDataMonitorLocalStorage(initialMonitorUser);
        setMonitorUser(initialMonitorUser);
        //console.log("haciendo Logout:..", initialMonitorUser);
        navigate("/loginMonitor");
      };
    const handleAction = (e) => {
        setActionMonitor(e.target.name);
    }
  return (
    <div>
        <HeaderMiniso />
        <div className='d-flex justify-content-end align-items-start gap-2 my-2 pe-3'>
            <h6 style={{height:'40px'}} className='fs-5 d-flex align-items-center'>MonitorUsers Admin</h6>
        <Dropdown>
      <Dropdown.Toggle variant="info" id="dropdown-basic">
        <MdMenu />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item name="0" onClick={handleAction}>Crear/Consultar/Editar</Dropdown.Item>
        <Dropdown.Item name="1" onClick={handleAction}>Eliminar</Dropdown.Item>
        <Dropdown.Item name="2" onClick={handleAction}>Ver Todos</Dropdown.Item>
        <Dropdown.Item href='#/monitor'>Monitoreo</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
        <button type='button' className='btn btn-light' onClick={handleHome}><IoHomeOutline /></button>
        <button onClick={handleLogout} className='btn btn-outline-info'>Logout</button>
        
        </div>
        <div className='my-3'>
        {actionMonitor&&actionsArray[Number(actionMonitor)]}
        </div>
        
        <FooterMiniso />
    </div>
  )
}

export default AdminMonitor